document.addEventListener("DOMContentLoaded", function () {
    if (!localStorage.getItem("popupShown")) {
      document.getElementById("popup").style.display = "flex";
      localStorage.setItem("popupShown", "true");
    }

    document.querySelectorAll(".popup-btn").forEach(button => {
      button.addEventListener("click", function () {
        document.getElementById("popup").style.display = "none";
      });
    });
  });